import React from "react";

import { Container } from "./shared";

import { ArrowLightRight } from "~/components/icons/ArrowLight";
import Spacer, { Axis } from "~/components/Spacer";

export default function MonitoredVaspLink({
  hasPadding = true,
  clickable = false,
}: {
  hasPadding: boolean;
  clickable: boolean;
}) {
  return (
    <Container hasPadding={hasPadding} clickable={clickable}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <img src={"/assets/monitored-vasp.svg"} />
        <Spacer axis={Axis.HORIZONTAL} size={12} />
        <div>MONITORED LIST</div>
      </div>
    </Container>
  );
}
